import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  personalInfo: {},
};

// Define the config slice
const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setPersonalInfo: (state, action) => {
      state.personalInfo = action.payload.personalInfo;
    },
  },
});

export const { setPersonalInfo } = configSlice.actions;

export default configSlice.reducer;
